import React, { useState } from "react";
import FadeInSection from "./FadeInSection"; // Keeps animation style
import "./DecisionAgentDemoSetup.css"; // Import the CSS file

const DecisionAgentDemoSetup = () => {
  const [review, setReview] = useState("");
  const [classification, setClassification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Real API Call
  const submitReview = async () => {
    if (!review.trim()) return; // Prevent empty submissions
    setLoading(true);
    setError(null); // Reset previous errors

    try {
      const response = await fetch("https://agentsserver.modlee.ai:5000/moderation", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ review }), // Send review as JSON payload
      });

      if (!response.ok) {
        throw new Error("Failed to fetch predictions from backend");
      }

      const data = await response.json();

      // Update classification results
      setClassification({
        llmPrediction: data.llmPrediction || "Error",
        dlmPrediction: data.dlPrediction || "Error",
      });
    } catch (error) {
      console.error("Error posting review:", error);
      setClassification(null); // Clear previous results on failure
      setError("Failed to analyze review. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <FadeInSection className="decision-agent-demo-container">
      <h2 className="decision-agent-demo-title">Example Application for E-Commerce</h2>

      {/* Three-column product showcase */}
      <div className="decision-agent-demo-grid">
        {[
          { name: "GlowMug", img_name:'glow_mug.svg', desc: "A self-warming smart mug that keeps drinks at the perfect temperature all day." },
          { name: "EchoMat", img_name:'echo_mat.svg', desc: "A smart yoga mat that gives real-time posture feedback and tracks progress." },
          { name: "AirChill Pro", img_name:'airchill_pro.svg', desc: "A portable mini air conditioner that provides instant cooling with a rechargeable battery." },
        ].map((product, index) => (
          <div key={index} className="decision-agent-demo-item">
            <img
              src={`${process.env.PUBLIC_URL}/${product.img_name}`} 
              alt="" 
              className="agent-image"
            />
            <h3 className="decision-agent-demo-subtitle">{product.name}</h3>
            <p className="decision-agent-demo-text">{product.desc}</p>
          </div>
        ))}
      </div>

      {/* Interactive Review Submission Section */}
      <div className="decision-agent-interactive">
        <h3 className="decision-agent-interactive-title">Agent-Powered Review Moderation</h3>
        <p className="decision-agent-interactive-text">
          Our Niche AI Agent moderates reviews 24/7, classifying them as positive, negative, or spam. <strong>Write a review</strong> for one of the proudcts above to see how our Niche Agent automatically classifies it in real-time.
        </p>        

        {/* Two-Column Layout for Review & Results */}
        <div className="decision-agent-review-container">
          
          {/* Left Column - Review Input */}
          <div className="decision-agent-review-column">
            <textarea
              className="decision-agent-textarea"
              placeholder="Write your review here..."
              value={review}
              onChange={(e) => setReview(e.target.value)}
              aria-label="Review input"
            ></textarea>

            <button
              className={`decision-agent-submit-button ${loading ? "loading" : ""}`}
              onClick={submitReview}
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? "Processing..." : "Submit Review"}
            </button>

            {/* Display Error Message if API Fails */}
            {error && <p className="decision-agent-error">{error}</p>}
          </div>

          {/* Right Column - Classification Results */}
          <div className="decision-agent-results-column">
            {classification ? (
              <div className="decision-agent-results">
                <p><strong>Agent Decisions</strong></p>
                <p>LLM Based: {classification.llmPrediction}</p>
                <p>Optimized Model: {classification.dlmPrediction}</p>
              </div>
            ) : (
              !loading && <p className="decision-agent-placeholder">Agent results will appear here...</p>
            )}
          </div>
        </div>
      </div>
    </FadeInSection>
  );
};

export default DecisionAgentDemoSetup;
